import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from '../../../../../components/ui/Dialog';
import { Button } from '../../../../../components/ui/Button';
import EditCompanyForm from '../EditCompanyForm';
import { apiService } from '../../../../../utils/api';
import CinForm from '../forms/CinForm';

const EditCompanyModal = ({
  visible,
  onClose,
  data = null,
  submitEditForm,
  error,
  title,
}: {
  visible?: any;
  onClose?: any;
  data?: any;
  submitEditForm?: any;
  error?: any;
  title?: any;
}) => {
  const [reset, setReset] = useState(false);
  const [icoVisible, setIcoVisible] = useState(false);
  const [aresData, setAresData] = useState(null);

  const formSubmit = (values) => {
    submitEditForm(values);
    setAresData(null);
  };

  const formSubmitIco = async (data) => {
    try {
      const { data: ares } = await apiService.get('/api/v1/company/data-ares/', {
        params: { ico: data.ico },
      });
      if (ares) {
        setAresData(ares);
        setIcoVisible(false);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const _onClose = () => {
    setAresData(null);
    onClose();
  };

  return (
    <>
      <Dialog open={visible} onOpenChange={_onClose}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <EditCompanyForm
              formProps={data}
              ares={aresData}
              error={error}
              reset={reset}
              resetConfirm={() => setReset(false)}
              onSubmit={formSubmit}
            />
          </DialogBody>
          <DialogFooter>
            <Button
              key={0}
              variant="outline"
              data-testid="company-modal-close-btn"
              onClick={() => onClose()}
            >
              Zavřít
            </Button>
            <Button
              key={1}
              variant="outline"
              data-testid="company-modal-load-ares-btn"
              onClick={() => setIcoVisible(true)}
            >
              Načíst z Ares
            </Button>
            <Button key={2} type="submit" form="company-form" data-testid="company-modal-save-btn">
              Uložit
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      <Dialog open={icoVisible} onOpenChange={() => setIcoVisible(false)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Zdejte IČO</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <CinForm onSubmit={formSubmitIco} />
          </DialogBody>
          <DialogFooter>
            <Button
              key={1}
              variant="outline"
              data-testid="cin-modal-close-btn"
              onClick={() => setIcoVisible(false)}
            >
              Zavřít
            </Button>
            <Button type="submit" form="cin-form" key={2} data-testid="cin-modal-submit-btn">
              Odeslat
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default EditCompanyModal;
